const menuConfig = [
  {
    name: 'touchpointBehavior',
    path: '/touchpoint-behavior',
    options: [
      {
        name: 'tenderMenu',
        path: '/tender-menu',
      },
      {
        name: 'branding',
        path: '/touchpoint-branding',
      },
      {
        name: 'commandMenu',
        path: '/command-menu',
      },
    ],
  },
  {
    name: 'barcode',
    path: '/barcodes',
    options: [
      {
        name: 'dataPatterns',
        path: '/data-pattern',
      },
    ],
  },
  {
    name: 'items',
    path: '/items',
    options: [
      {
        name: 'onlinePurchaseProfile',
        path: '/online-purchase-profile',
      },
      {
        name: 'pluGroups',
        path: '/plu-groups',
      },
      {
        name: 'pluMenus',
        path: '/plu-menus',
      },
    ],
  },
  {
    name: 'return',
    path: '/return',
    options: [
      {
        name: 'returnPolicies',
        path: '/return-policies',
      },
    ],
  },
  {
    name: 'rules',
    path: '/rules',
    options: [
      {
        name: 'ageRestrictions',
        path: '/age-restriction',
      },
      {
        name: 'businessRules',
        path: '/business-rules',
      },
      // {
      //   name: 'pharmacyPolicy',
      //   path: '/pharmacy-policy',
      // },
    ],
  },
  {
    name: 'tax',
    path: '/tax',
    options: [
      {
        name: 'taxAuthorities',
        path: '/tax-authorities',
      },
      {
        name: 'taxBrackets',
        path: '/tax-brackets',
      },
      {
        name: 'taxParameters',
        path: '/tax-parameters',
      },
      {
        name: 'taxRates',
        path: '/tax-rates',
      },
      {
        name: 'taxZones',
        path: '/tax-zones',
      },
    ],
  },
  {
    name: 'tendering',
    path: '/tendering',
    options: [
      {
        name: 'currencies',
        path: '/currency',
      },
      {
        name: 'currencyExchangeRates',
        path: '/currency-exchange-rate',
      },

      // {
      //   name: 'tenderFeePolicy',
      //   path: '/tender-fee-policy',
      // },
      {
        name: 'tender',
        path: '/tender',
      },
      {
        name: 'tenderExchange',
        path: '/tender-exchange',
      },
      {
        name: 'tenderItemRestriction',
        path: '/tender-item-restrictions',
      },
    ],
  },
  {
    name: 'usWicTendering',
    path: '/us-wic-tendering',
    options: [
      {
        name: 'wicBetPolicy',
        path: '/wic-bet-policy',
      },
      {
        name: 'wicEbtAgencies',
        path: '/wic-ebt-agencies',
      },
      {
        name: 'wicCVBMappings',
        path: '/wic-cvb-mapping',
      },
      {
        name: 'wicProductExclusions',
        path: '/wic-product-exclusions',
      },
    ],
  },
];

export default menuConfig;
